import { maybe, Maybe } from '@passionware/monads';
import { createSimpleStore, useSimpleStore } from '@passionware/simple-store';
import { DevOrigin } from 'v5/platform/dev-origin/devOrigin.protocol';
import { DevOriginService } from './DevOriginService';

/** How the service hears from the dev server — Vite's HMR socket in the app. */
export interface DevOriginChannel {
  /** Asks the server for the current origin, answered through `onOrigin`. */
  request: () => void;
  /** An answer, or a push after HEAD moved. */
  onOrigin: (listener: (origin: DevOrigin) => void) => void;
  /** Each time the socket (re)connects. */
  onConnect: (listener: () => void) => void;
}

/** Without a channel — a build — the origin stays absent. */
export function createDevOriginService(
  channel: Maybe<DevOriginChannel>
): DevOriginService {
  const store = createSimpleStore<Maybe<DevOrigin>>(maybe.ofAbsent());

  if (maybe.isPresent(channel)) {
    channel.onOrigin(origin => store.setNewValue(origin));
    // the socket may connect after this runs; after a reconnect the server may even have been
    // restarted from another checkout
    channel.request();
    channel.onConnect(() => channel.request());
  }

  return {
    useOrigin: () => useSimpleStore(store)
  };
}
